import _ from 'lodash';
import React from 'react';

import RefData from 'ref-data';

import OneTrust from './OneTrust';
import CookieBot from './CookieBot';
import TrustArc from './TrustArc';

//Supported Cookie Consent Management providers
const PROVIDERS = {
  ONE_TRUST:  'oneTrust',
  COOKIE_BOT: 'cookieBot',
  TRUST_ARC:  'trustArc',
};

//Configs for each privacy provider. Adds information as 'fields' a user has to fill in for a provider, points HTML/CSS/JS section code and help.
const PROVIDER_CONFIGS = {
  [PROVIDERS.ONE_TRUST]: {
    name:     'OneTrust',
    id:       'one_trust',
    helpText: `The Data Domain Script is explained in the following articles: <a href="https://my.onetrust.com/s/article/UUID-2dc719a8-4be5-8d16-1dc8-c7b4147b88e0" target="_blank">OneTrust Cookies</a> and <a href="https://my.onetrust.com/s/article/UUID-7478d3b4-18eb-3ac0-a6fd-fb7ebff9f8dc" target="_blank">Publishing and Implementing Cookie Consent Scripts</a>.<br />
    Learn how to Find the Cookie IDs <a href="https://my.onetrust.com/s/article/UUID-8102e851-d860-d465-d8d6-b1d636d68eb9" target="_blank">here</a>.<br />
    Please note that you need to be logged into your OneTrust account to access the above articles.`,
    sections: {
      Javascript: {
        info: <OneTrust.JSHelp />,
      },
    },
  },
  [PROVIDERS.COOKIE_BOT]: {
    name:     'Cookiebot',
    id:       'cookie_bot',
    sections: {
      Javascript: {
        info: <CookieBot.JSHelp />,
      },
    },
  },
  [PROVIDERS.TRUST_ARC]: {
    name:     'TrustArc',
    id:       'trust_arc',
    sections: {
      Javascript: {
        info: <TrustArc.JSHelp />,
      },
      CSS: {
        info: <TrustArc.CSSHelp />,
      },
    },
  },
};

//provider options list as accepted by SingleSelect
const PROVIDERS_OPTIONS = _.map(PROVIDER_CONFIGS, (config, key) => ({
  text:  config.name,
  value: key,
}));

//list of privacy options, as accepted by the Radio Group component
const getPrivacyOptionsList = _.memoize(
  (experienceFormatType, isMicrosite, isAccountPage) => [
    {
      label:       'None',
      description:
        'The Grow platform will not implement any Cookie Consent Management and will work without any restriction',
      value: RefData.Enum.STRATEGY.PRIVACYMGMT.NONE,
    },
    {
      label:       'Grow Cookie Consent',
      description:
        'A preference center will be included and displayed to users, with the experience adapting to user preferences',
      value: RefData.Enum.STRATEGY.PRIVACYMGMT.DEFAULT,
    },
    {
      label:       'Custom API',
      description: (
        <span>
          Provide user's privacy preferences from the parent page or a 3rd party solution to the experience using a{' '}
          <a
            href="#"
            onClick={() =>
              loadMadCapFlare(
                experienceFormatType === RefData.Enum.FORMAT.DISPLAY.MICRO
                  ? MADCAP_ARTICLES.PRIVACY_MANAGEMENT_API_FOR_NEXTGEN_EXPERIENCES
                  : MADCAP_ARTICLES.PRIVACY_MANAGEMENT_API_FOR_MACRO_EXPERIENCES
              )
            }
          >
            simple api
          </a>
        </span>
      ),
      value: RefData.Enum.STRATEGY.PRIVACYMGMT.CUSTOM,
    },
    {
      label:       '3P Cookie Consent',
      description: (
        <span>
          Provide user's privacy preferences to the experience{' '}
          <a href="#" onClick={() => loadMadCapFlare(MADCAP_ARTICLES.HOW_TO_ADD_A_COOKIE_BANNER_TO_YOUR_EXPERIENCES)}>
            from 3rd party solution
          </a>{' '}
          implemented on the parent page.{' '}
          <Choose>
            <When condition={isMicrosite}>On saving, this will automatically be applied to the microsite.</When>
            <When condition={isAccountPage}>
              You will need to copy and incorporate the code on the publishing page into the parent page.
            </When>
            <Otherwise>You will need to copy and incorporate the code below into the parent page.</Otherwise>
          </Choose>
        </span>
      ),
      value: RefData.Enum.STRATEGY.PRIVACYMGMT.CUSTOM3RDPARTY,
    },
  ],
  (experienceFormatType, isMicrosite) => `cache-${experienceFormatType}-${isMicrosite}`
);

export { PROVIDERS, PROVIDERS_OPTIONS, getPrivacyOptionsList, PROVIDER_CONFIGS };
